import React, { useState, useEffect } from 'react'
import { DashboardLayout, Toaster, Dropdown, Button, MultiFilters, GeneralTable } from 'components'
import 'assets/scss/billingPortal/modules/mobileLicenseKey.scss';
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { useCustomSelector } from 'hooks';
import { isArrayNotEmpty, isNotNullUndefined, isObjectEmpty, getTotalCountFromHeader, isArrayEmpty, isNullUndefined } from 'functions';
import { useControlTableColumns } from './hooks/useControlTableColumns';
import useMobileLicenseKey from 'dataflow/billingPortal/actions/useMobileLicenseKey.actions';
import { useSwitchTrialStatus } from './hooks/useSwitchTrialStatus';
import { useSetDeletedDate } from './hooks/useSetDeletedDate';
import { useAddLicense } from './hooks/useAddLicense';
import ic_add_account from "assets/images/ic_add_account.svg";
import { useExtendDate } from './hooks/useExtendDate';
import { statusOptions } from './constants/constant';
import { SubmenuTooltip } from 'components/informational/SubmenuTooltip';
import { MoreButton } from 'components/buttons/MoreButton';
import ic_export from 'assets/images/ic_export.svg';
import useExportData from './hooks/useExportData';

export default function MobileLicenseKeyControl() {

    const [pageTitle] = useState("COM ID")
    const [comId, setComId] = useState(0);
    const [isLicensePackage, setisLicensePackage] = useState(false);
    const [isTableRefreshRequired, setisTableRefreshRequired] = useState(false)

    const { userPermissions } = useCustomSelector("userManagementReducers");
    const { allComList } = useCustomSelector("accountControl");
    const { getAllComList } = useAccountControlActions();

    let { 
        getLicensePackage_requesting, licensePackage, licensePackageHeaders, 
        switchTrial_isSuccessful, updateDeleteDate_isSuccessful, generateLicense_isSuccessful, extendDate_isSuccessful,
        packageNameList
    } = useCustomSelector("mobileLicenseKey");

    const { setLicensePackageComId, getPackageList, getLicensePackage } = useMobileLicenseKey();

    const exportData = useExportData();

    useEffect(() => {
        getAllComList();
        getPackageList();
    }, []);

    useEffect(() => {
        if (switchTrial_isSuccessful) {
            setisTableRefreshRequired(true);
        }
    }, [switchTrial_isSuccessful]);
    useEffect(() => {
        if (updateDeleteDate_isSuccessful) {
            setisTableRefreshRequired(true);
        }
    }, [updateDeleteDate_isSuccessful]);
    useEffect(() => {
        if (generateLicense_isSuccessful) {
            setisTableRefreshRequired(true);
        }
    }, [generateLicense_isSuccessful]);
    useEffect(() => {
        if (extendDate_isSuccessful) {
            setisTableRefreshRequired(true);
        }
    }, [extendDate_isSuccessful]);
    useEffect(() => {
        if (isTableRefreshRequired) setisTableRefreshRequired(false);
    }, [isTableRefreshRequired])

    const {
        modalDisplay: trialStatusModal,
        updateModalState: updateTrialStatusModalState
    } = useSwitchTrialStatus({ comId })

    const {
        modalDisplay: deletedDateModal,
        updateModalState: updateDeletedDateModalState
    } = useSetDeletedDate({ comId })

    const {
        modalDisplay: addLicenseModal,
        updateModalState: updateAddLicenseModalState
    } = useAddLicense({ comId, packageNameList })

    const {
        modalDisplay: extendDateModal,
        updateModalState: updateExtendDateModalState
    } = useExtendDate({ comId })

    const columns = useControlTableColumns({ updateTrialStatusModalState, updateDeletedDateModalState, updateExtendDateModalState })

    function searchLicensePackage() {
        setLicensePackageComId(comId)
        setisLicensePackage(true)
    }

    let mainDisplay = (
        <div className='mobile-license-key__content'>
            <div className={'mobile-license-key__content-body'}>
                <div className={"row"}>
                    <div className='col-12 col-lg-5 pb-4'>
                        <Dropdown
                            options={(isArrayNotEmpty(allComList))? allComList.map((obj) => {
                                let comId = obj?.ComId? obj.ComId:"";
                                let comName = obj?.ComName? obj?.ComName:"";

                                return {
                                    label: comId + " - " + comName,
                                    value: comId
                                };
                            }):""}
                            selectedValue_default={comId}
                            onChange={(value, label) => {
                                setComId(value)
                            }}
                            onEnterKeyPressed={searchLicensePackage}
                            label={pageTitle}
                            isLabelLegend isSearchable isClearable
                        />
                    </div>
                    <div className='col-12 col-lg-2 pt-0 pt-lg-4'>
                        <Button
                            className={"grab-button__input float-right float-lg-none"}
                            isLoading={getLicensePackage_requesting}
                            isDisabled={getLicensePackage_requesting}
                            handleOnClick={searchLicensePackage}
                        >
                            Search
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )

    let licensePackageDisplay = (
        <GeneralTable
            className={"mobile-license-key__main-table"}
            columns={columns}
            data={licensePackage}

            getTableData={getLicensePackage}

            outerTableHeader={(outerTableHeader_props) => {
                const { 
                    filterOptions, setFilterOptions
                } = outerTableHeader_props;

                return (
                    <div className={"table__headers"}>
                        {/* modal */}
                        {trialStatusModal}

                        {deletedDateModal}

                        {addLicenseModal}

                        {extendDateModal}

                        {/* Top Section */}
                        <div className={"headers__top-section d-flex justify-content-between align-items-center mt-4 mb-4"}>
                            {/* Title */}
                            <div className={"headers__title tableHeaderTitle "}>
                                {pageTitle} - {comId}
                            </div>

                            <div className={"header__action d-flex align-items-center"}>
                                <div className={"action__main-action-wrapper"}>
                                    {userPermissions?.Internal_License_Create && (
                                        <Button
                                            className={"headers__add-button"}
                                            handleOnClick={() => updateAddLicenseModalState(true)}
                                        >
                                            <img
                                                className={"px-2"}
                                                src={ic_add_account}
                                                alt={"Add Icon"}
                                            />
                                            Add Trial License
                                        </Button>
                                    )}
                                </div>

                                {/* More Actions */}
                                <SubmenuTooltip
                                    className={"action__more-actions-wrapper ml-2"}
                                    menuItems={[
                                        {
                                            icon: ic_export,
                                            label: "Export",
                                            isDisabled: isArrayEmpty(licensePackage) || isNullUndefined(licensePackage),
                                            onClick: () => {
                                                exportData(licensePackage);
                                            },
                                        }
                                    ]}
                                >
                                    <MoreButton
                                        className={"more-actions-wrapper__more-actions"}
                                        iconClassName={"more-actions__icon"}
                                    />
                                </SubmenuTooltip>
                            </div>
                        </div>

                        {/* Bottom Section */}
                        <div className={"headers__bottom-section"}>
                            <MultiFilters
                                defaultFilterOption={{
                                    label: "Product Name", 
                                    propertyName: "packageName",
                                    placeholder: "Product Name",
                                    options: (isArrayNotEmpty(packageNameList))? packageNameList.map((obj) => {
                                        let packageId = obj?.packageName? obj.packageName:"";
                                        let packageName = obj?.packageName? obj?.packageName:"";

                                        return {
                                            label: packageName,
                                            value: packageId
                                        };
                                    }):"",
                                    inputType: "dropdown",
                                }}
                                filterOptions={[
                                    {
                                        label: "Product Name", 
                                        propertyName: "packageName",
                                        placeholder: "Product Name",
                                        options: (isArrayNotEmpty(packageNameList))? packageNameList.map((obj) => {
                                            let packageId = obj?.packageName? obj.packageName:"";
                                            let packageName = obj?.packageName? obj?.packageName:"";
    
                                            return {
                                                label: packageName,
                                                value: packageId
                                            };
                                        }):"",
                                        inputType: "dropdown",
                                    },
                                    {
                                        label: "License Key", 
                                        propertyName: "licenseKey",
                                        placeholder: "License Key",
                                        inputType: "search",
                                    },
                                    {
                                        label: "Deleted", 
                                        propertyName: "isdeleted",
                                        placeholder: "Deleted",
                                        options: statusOptions,
                                        inputType: "dropdown"
                                    },
                                    {
                                        label: "Trial Status", 
                                        propertyName: "isTrial",
                                        placeholder: "Trial Status",
                                        options: statusOptions,
                                        inputType: "dropdown"
                                    },
                                    {
                                        label: "Trial Expired", 
                                        propertyName: "isTrialExpired",
                                        placeholder: "Trial Expired",
                                        options: statusOptions,
                                        inputType: "dropdown"
                                    }
                                ]}
                                dropdownPlaceholder={"Select Filter"}
                                onApplyFilter={(inputFilters) => {
                                    setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                }}
                            />
                        </div>
                    </div>
                );
            }}
            
            isTableDataLoading={getLicensePackage_requesting}

            isUsingPagination
            totalRecords={getTotalCountFromHeader(licensePackageHeaders)}

            isTableRefreshRequired={isTableRefreshRequired}
            isExpanderRequired isRowExpanderColumnFirst
            isColumnResizeable
            isTableOddRowsDarken
        />
    )

    return (
        <DashboardLayout
            headerTitle={"Product License Key Control"}

            bodyClassName={"mobile-license-key"}
            isHeaderCloseIconVisible={isLicensePackage}
            updateParentState_visiblity={isLicensePackage? setisLicensePackage:null}
            body={isLicensePackage? licensePackageDisplay:mainDisplay}
        />
    )
}